import { ReactElement } from 'react'

import FindByIdImpl from 'modules/lotes/domain/usecases/FindByIdImpl'
import VerificaCargaDisponivelImpl from 'modules/lotes/domain/usecases/VerificaCargaDisponivelImpl'

import FindAllImpl from '../../domain/usecases/FindAllImpl'
import LoteRepository from '../../infra/repositories/LoteRepository'
import ListLotes from '../../pages/ListLotes'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import ValidateRequisitosViagemImpl from 'modules/user/domain/usecases/ValidateRequisitosViagemImpl'
import { ListFrotista } from 'modules/user/domain/usecases/ListFrotista'
import ValidateLoteQuarteirizadoImpl from 'modules/lotes/domain/usecases/ValidateLoteQuarteirizado'

export const ListLotesFactory = (): ReactElement => {
  const loteRepository = new LoteRepository()
  const usuarioRepository = new UserRepository()
  const findAllImpl = new FindAllImpl(loteRepository)
  const findByIdImpl = new FindByIdImpl(loteRepository)
  const validateRequisitosViagemImpl = new ValidateRequisitosViagemImpl(
    usuarioRepository,
  )
  const verificaCargaDisponivelImpl = new VerificaCargaDisponivelImpl(
    loteRepository,
  )
  const listFrotistas = new ListFrotista(usuarioRepository)
  const validateLoteQuarteirizado = new ValidateLoteQuarteirizadoImpl(
    loteRepository,
  )

  return (
    <ListLotes
      findAll={findAllImpl}
      findById={findByIdImpl}
      verificaCargaDisponivel={verificaCargaDisponivelImpl}
      validateRequisitosViagem={validateRequisitosViagemImpl}
      listFrotistas={listFrotistas}
      validateLoteQuarteirizado={validateLoteQuarteirizado}
    />
  )
}
